import { useApolloClient } from "@apollo/client";
import React from "react";
import { useProductBox_SetItemProductMutation } from "../../doc-items/boxes/ProductBox.generated.js";

interface Options {
  projectId: string;
  docId: string;
  expandedItemIds: string[] | undefined;
}

export type SetItemProductFn = (
  itemId: string,
  product: { articleNumber: string; supplierId?: string | null }
) => Promise<void>;

export function useSetItemProduct({
  projectId,
  docId,
  expandedItemIds,
}: Options) {
  const client = useApolloClient();
  const [setItemProductMutation] = useProductBox_SetItemProductMutation({
    client,
  });

  const setItemProduct: SetItemProductFn = React.useCallback(
    async (itemId, product) => {
      const result = await setItemProductMutation({
        variables: {
          input: {
            projectId,
            docId,
            itemId,
            productArticleNumber: product.articleNumber,
            productSupplierId: product.supplierId ?? "",
            expandedItemIds,
          },
        },
      });
      if (result.errors?.length) {
        throw new Error(result.errors[0].message);
      }
      if (!result.data) {
        throw new Error("Could not set item product");
      }
    },
    [setItemProductMutation, projectId, docId, expandedItemIds]
  );

  return { setItemProduct };
}
